import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Carousel,
  CarouselControl,
  CarouselIndicators,
  CarouselItem,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import ArrowRight from "../../../assets/icon/arrow-right-purple.svg";
import PatientsDemographic from "components/PatientsDemographic";
import HoverImage from "react-hover-image/build";
import drugLightIcon from "../../../assets/icon/drug-with-reddot.svg";
import drugPurpleIcon from "../../../assets/icon/drug-status.svg";
import drugList from "../../../assets/icon/drug-list.svg";
import drugWhite from "../../../assets/icon/druglist-green.svg";
import closeIcon from "../../../assets/icon/close-icon.svg";
import threeDotsIcon from "../../../assets/icon/3-dots.svg";
import plusIcon from "../../../assets/icon/plus-icon-add-note.svg";
import uploadIcon from "../../../assets/icon/upload-icon.svg";
import productImage from "../../../assets/images/product-image.png";
import ClaimsInfo from "pages/OrderEntry/ClaimsInfo";
import DrugUtilPopUp from "pages/OrderEntry/DrugUtilPopUp";
import Drawer from "components/Drawer";
import MessageIconDark from "../../../assets/icon/messageIcon-dark.svg";
import MessageIconLight from "../../../assets/icon/messageIcon-light.svg";
import completeIcon from "../../../assets/icon/complete.svg";
import leftArrow from "../../../assets/icon/left-arrow.svg";
import statusPurple from "../../../assets/icon/status-save-icon.svg";
import rxHistory from "../../../assets/icon/rx-history-icon.svg";
import patientProfile from "../../../assets/icon/patient-profile.svg";

import { toast } from "react-toastify";

const FinalReviewDetailsPage = () => {
  const [openOne, setOpenOne] = useState("1");
  const [openTwo, setOpenTwo] = useState("");
  const [openThree, setOpenThree] = useState("");
  const [openFour, setOpenFour] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [drugUtil, setDrugUtil] = useState(false);
  const [claimsInfo, setClaimsInfo] = useState(false);

  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/workflow-final");
  };

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };
  const items = [
    {
      src: productImage,
      key: 1,
    },
    {
      src: productImage,
      key: 2,
    },
  ];
  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
        {" "}
        <img
          src={item.src}
          style={{ display: "flex", justifyContent: "center", margin: "auto" }}
        />
      </CarouselItem>
    );
  });

  const namesData = {
    fullName: "Doe, John",
    firstName: "John",
    lastName: "Doe",
    phone: "(555) 123-4567",
    dob: "01/08/1996 (28 Years)",
    address: "123, Main ST Anytown, USA, 12345",
  };

  const togglebtnOne = (id) => {
    if (openOne === id) {
      setOpenOne();
    } else {
      setOpenOne(id);
    }
  };
  const togglebtnTwo = (id) => {
    if (openTwo === id) {
      setOpenTwo();
    } else {
      setOpenTwo(id);
    }
  };
  const togglebtnThree = (id) => {
    if (openThree === id) {
      setOpenThree();
    } else {
      setOpenThree(id);
    }
  };
  const togglebtnFour = (id) => {
    if (openFour === id) {
      setOpenFour();
    } else {
      setOpenFour(id);
    }
  };

  return (
    <>
      <Container fluid className="details-page-body bg-white  p-3">
        <Container fluid>
          <div className="d-flex justify-content-between gap-2 orderEntry-heading section-devider-border pb-2 mb-2">
            <div className="d-flex justify-content-center align-items-center gap-2">
              <img
                src={leftArrow}
                onClick={handleBack}
                className="cursor-pointer left-arrow-btn"
              />
              <div className="heading-text"> Order Details (Rx-1029484)</div>
            </div>
            <div className="d-flex justify-content-center align-items-center gap-4">
              <div
                className="d-flex justify-content-end"
                style={{ fontSize: "16px" }}
              >
                <div onClick={undefined} className="">
                  {/* {openStatus ? (
                              <img src={purpleCrossIcon} alt="icon" />
                            ) : ( */}
                  <img src={statusPurple} alt="icon" />
                  {/* )}{" "} */}
                  <span style={{ marginLeft: "8px" }}>Order Status</span>
                </div>
              </div>
            </div>
          </div>
          <div>
            <PatientsDemographic
              fullName={namesData.fullName}
              firstName={namesData.firstName}
              lastName={namesData.lastName}
              dob={namesData.dob}
              phone={namesData.phone}
              address={namesData.address}
            />
          </div>
          <div>
            <div className="logo-drawer">
              <Row>
                <Col className="d-flex justify-content-start gap-2">
                  <div
                    onClick={() => setDrugUtil(!drugUtil)}
                    id="ScheduleUpdateTooltip"
                  >
                    <HoverImage
                      className="drug-status"
                      src={drugPurpleIcon}
                      hoverSrc={drugLightIcon}
                      alt=""
                    />

                    <UncontrolledTooltip
                      placement="bottom"
                      target="ScheduleUpdateTooltip"
                      trigger="hover"
                    >
                      Drug Utilization Review
                    </UncontrolledTooltip>
                  </div>
                  <div
                    onClick={() => setClaimsInfo(!claimsInfo)}
                    id="ScheduleUpdateTooltip2"
                  >
                    <HoverImage
                      className="drug-status"
                      src={drugList}
                      hoverSrc={drugWhite}
                      alt=""
                    />
                    <UncontrolledTooltip
                      // className="tooltip-custom"
                      style={{ position: "relative", left: "30px" }}
                      placement="bottom"
                      target="ScheduleUpdateTooltip2"
                      trigger="hover"
                    >
                      Claims Information
                    </UncontrolledTooltip>
                  </div>
                  <div
                    // className="drug-status"
                    onClick={() => setClaimsInfo(!claimsInfo)}
                    id="ScheduleUpdateTooltip3"
                  >
                    <HoverImage
                      src={MessageIconDark}
                      className="drug-status"
                      hoverSrc={MessageIconLight}
                      alt=""
                    />
                    <UncontrolledTooltip
                      // className="tooltip-custom"
                      style={{ position: "relative", left: "30px" }}
                      placement="bottom"
                      target="ScheduleUpdateTooltip3"
                      trigger="hover"
                    >
                      Comments
                    </UncontrolledTooltip>
                  </div>
                  <div className="comment">
                    <img src={completeIcon} alt="not available" />
                    340B Eligible
                  </div>
                </Col>
                <Col className="d-flex justify-content-end gap-2">
                  <Button color="primary" className="reset">
                    <img src={patientProfile} />
                    Patient Details
                  </Button>
                  <Button className="back-button primary">
                    <img src={rxHistory} /> Rx History
                  </Button>
                  <Dropdown
                    isOpen={dropdownOpen}
                    toggle={() => setDropdownOpen(!dropdownOpen)}
                  >
                    <DropdownToggle color="primary" className="togglebtn">
                      {dropdownOpen ? (
                        <img src={closeIcon} alt="icon" />
                      ) : (
                        <img src={threeDotsIcon} alt="icon" />
                      )}
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem className="dropdownitem-border">
                        <img src={plusIcon} /> Add Notes
                      </DropdownItem>
                      <DropdownItem className="dropdownitem-border">
                        {" "}
                        <img src={uploadIcon} /> Print
                      </DropdownItem>
                      <DropdownItem className="dropdownitem-border">
                        {" "}
                        <img src={uploadIcon} /> E-Rx Details{" "}
                      </DropdownItem>
                      <DropdownItem className="dropdownitem-border">
                        {" "}
                        <img src={uploadIcon} /> Forward Rx
                      </DropdownItem>
                      <DropdownItem className="dropdownitem-border">
                        {" "}
                        <img src={uploadIcon} /> Due
                      </DropdownItem>
                      <DropdownItem className="dropdownitem-border">
                        {" "}
                        <img src={uploadIcon} /> P/A
                      </DropdownItem>
                      <DropdownItem className="dropdownitem-border">
                        {" "}
                        <img src={uploadIcon} /> Rx History
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </Col>
              </Row>
            </div>
            <div className="final-review-accordian-div">
              <Accordion open={openOne} toggle={togglebtnOne}>
                <AccordionItem>
                  <AccordionHeader targetId="1">Final Review</AccordionHeader>
                  <AccordionBody accordionId="1">
                    <Row>
                      <Col>
                        <h2 className="heading-pres">Product Images</h2>
                      </Col>
                      <Col>
                        <div className="final-acc-header">
                          New E-Prescription Summary
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={6}
                        sm={12}
                        style={{
                          backgroundColor: "#F7F7F7",
                          borderTop: "1px solid #d3d3d3",
                        }}
                      >
                        <div className="final-review-corousel">
                          <Carousel
                            activeIndex={activeIndex}
                            next={next}
                            previous={previous}
                          >
                            <CarouselIndicators
                              items={items}
                              activeIndex={activeIndex}
                              onClickHandler={goToIndex}
                              style={{ position: "relative", top: "220px" }}
                            />
                            {slides}
                            <CarouselControl
                              direction="prev"
                              directionText="Previous"
                              onClickHandler={previous}
                            ></CarouselControl>

                            <CarouselControl
                              direction="next"
                              directionText="Next"
                              onClickHandler={next}
                            />
                          </Carousel>
                        </div>
                        <Row style={{ marginTop: "48px" }}>
                          <Col lg={5} className="final-review-key">
                            NDC :{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            43799096201
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Product Name :{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            Venlafaxine ER Tablet 150MG
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Manufacturer :{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            Teva
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Package Size:{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            100 EA
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Quantity on Hand :{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            10
                          </Col>
                        </Row>
                        <Row style={{ marginBottom: "30px" }}>
                          <Col lg={5} className="final-review-key">
                            Description :{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            Off-white, Oblong, Capsule, 302 IA150
                          </Col>
                        </Row>
                      </Col>
                      <Col
                        style={{
                          paddingLeft: "20px",
                        }}
                        md={6}
                        sm={12}
                      >
                        <Row
                          style={{
                            borderTop: "1px solid #d3d3d3",
                            paddingTop: "8px",
                          }}
                        >
                          <Col lg={5} className="final-review-key">
                            Rx Number :{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            1038572
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Patient Name :{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            Doe, John
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Birth Date :{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            01/08/1996
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Phone :{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            (555) 978-6543
                          </Col>
                        </Row>
                        <Row className="final-e-summary"></Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Prescriber Name :{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            Smith, Robert
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            NPI :{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            1828492801
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Office Address :{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            1234 Maple Road, Anytown, USA
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Office Phone :{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            (555) 978-6543
                          </Col>
                        </Row>
                        <Row className="final-e-summary"></Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Date Written :{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            12/19/2024
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Medication :{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            Venlafaxine ER Tablet 150MG
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            DAW :{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            O-Not Specified
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Quantity :{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            30 EA
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Days Supply :{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            30
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Refills :{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            5
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Directions :{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            Take 1 Tablet by Mouth Daily
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={5} className="final-review-key">
                            Note :{" "}
                          </Col>
                          <Col lg={7} className="final-review-value">
                            Please contact the office to report any insurance
                            issues
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </AccordionBody>
                </AccordionItem>
              </Accordion>
              <Accordion open={false} toggle={togglebtnTwo} className="mt-2">
                <AccordionItem>
                  <AccordionHeader targetId="2">
                    Order Overview{" "}
                  </AccordionHeader>
                  <AccordionBody accordionId="2">
                    <Row>
                      <Col md={6} style={{ borderRight: "1px solid #D3D3D3" }}>
                        <Row className="mb-8">
                          <Col md="4">
                            <div className="pdetails">Product Number</div>
                            <div className="patient-details">0029-0238-90</div>
                          </Col>
                          <Col md="4">
                            <div className="pdetails">Product Name</div>
                            <div className="patient-details">
                              Venlafaxine ER 150 Capusle
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="pdetails">Manufacturer</div>
                            <div className="patient-details">Teva</div>
                          </Col>
                        </Row>
                        <Row className="mb-8">
                          <Col md="4">
                            <div className="pdetails">Quantity On Hand</div>
                            <div className="patient-details">10</div>
                          </Col>
                          <Col md="4">
                            <div className="pdetails">NDC (Center)</div>
                            <div className="patient-details">42799096201</div>
                          </Col>
                          <Col md="4">
                            <div className="pdetails">340B</div>
                            <div className="patient-details">X</div>
                          </Col>
                        </Row>
                        <Row className="mb-8">
                          <Col md={4}>
                            <div className="pdetails">Description</div>
                            <div className="patient-details">
                              Off-White, Oblong, capsule, 302 IA150
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col md={6} sm={12}>
                        <div>
                          <Carousel
                            activeIndex={activeIndex}
                            next={next}
                            previous={previous}
                          >
                            <CarouselIndicators
                              items={items}
                              activeIndex={activeIndex}
                              onClickHandler={goToIndex}
                              style={{ position: "relative", top: "220px" }}
                            />
                            {slides}
                            <CarouselControl
                              direction="prev"
                              directionText="Previous"
                              onClickHandler={previous}
                            ></CarouselControl>

                            <CarouselControl
                              direction="next"
                              directionText="Next"
                              onClickHandler={next}
                            />
                          </Carousel>
                        </div>
                      </Col>
                    </Row>
                  </AccordionBody>
                </AccordionItem>
              </Accordion>
              <Accordion open={false} toggle={togglebtnThree} className="mt-2">
                <AccordionItem>
                  <AccordionHeader targetId="3">
                    Packaging Details
                  </AccordionHeader>
                  <AccordionBody accordionId="3"></AccordionBody>
                </AccordionItem>
              </Accordion>
              <Accordion open={false} toggle={togglebtnFour} className="mt-2">
                <AccordionItem>
                  <AccordionHeader targetId="4">
                    Additional Information
                  </AccordionHeader>
                  <AccordionBody accordionId="4"></AccordionBody>
                </AccordionItem>
              </Accordion>
            </div>
          </div>
        </Container>
        <Container fluid className="final-review-detail-footer">
          <Button color="primary" className="reset">
            Send Back
          </Button>
          <Button className="back-button">Edit</Button>
          <Button
            color="primary"
            className="submit"
            onClick={() =>
              toast.success("E-Prescription has successfully approved")
            }
          >
            Approve
          </Button>
        </Container>
      </Container>
      <div>
        <Drawer
          direction="end"
          size="lg"
          isOpen={drugUtil}
          toggle={() => setDrugUtil(!drugUtil)}
          title="Drug Utilization Review"
        >
          <DrugUtilPopUp />
        </Drawer>
        <Drawer
          direction="end"
          size="lg"
          isOpen={claimsInfo}
          toggle={() => setClaimsInfo(!claimsInfo)}
          title="Claims Information"
        >
          <ClaimsInfo />
        </Drawer>
      </div>
    </>
  );
};

export default FinalReviewDetailsPage;
